import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';

import { concatMap, mergeMap } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CreateAssetSuccess, FinishAssetUpload } from '../action-creators';
import { CREATE_ASSET_SUCCESS } from '../actions';
import getAssetActions from '../utils/get-asset-actions';
import { Action } from 'redux';

export const finishUploadEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, CreateAssetSuccess>(CREATE_ASSET_SUCCESS),
    mergeMap(async (action) => {
      try {
        await action.response.upload.request;
        return [new FinishAssetUpload(action.response.id)];
      } catch (e) {
        const error =
          typeof e === 'string' && e.length > 0
            ? e
            : e.message
            ? e.message
            : undefined;
        const actions: Action[] = getAssetActions(action.response.id, error);
        return actions;
      }
    }),
    concatMap((actions) => actions)
  );
